import { createAction } from "typesafe-actions";
import { AuthorActionTypes } from "./author-types";
import { AuthorSearchParams, AuthorState } from "./author-reducer";

export interface AuthorRequest extends AuthorSearchParams {
    apiUrl: string;
}

export interface AuthorResponse
    extends Pick<AuthorState, "authors" | "displayedOutOfTotalLabel" | "totalCount" | "totalCountLabel">,
        Pick<AuthorSearchParams, "page"> {}

export interface PopulateAuthors extends Pick<AuthorState, "authors"> {}

export const authorSearchRequest = createAction(
    AuthorActionTypes.AUTHOR_REQUEST,
    action => (payload: AuthorRequest) => action(payload)
);

export const authorSearchSuccess = createAction(
    AuthorActionTypes.AUTHOR_SUCCESS,
    action => (payload: AuthorResponse) => action(payload)
);

export const authorSearchError = createAction(
    AuthorActionTypes.AUTHOR_ERROR,
    action => (payload: AuthorResponse) => action(payload)
);

export const populateAuthors = createAction(
    AuthorActionTypes.POPULATE_AUTHORS,
    action => (payload: PopulateAuthors) => action(payload)
);

export const updateAuthorParams = createAction(
    AuthorActionTypes.UPDATE_AUTHOR_PARAMS,
    action => (payload: AuthorSearchParams) => action(payload)
);
